var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "h5 font-weight-bold text-dark bg-light p-4 border rounded",
    },
    [
      _vm.hasControl
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _c("div", { staticClass: "d-flex flex-column" }, [
                _vm.label
                  ? _c(
                      "label",
                      {
                        staticClass: "mb-2 font-weight-bold",
                        attrs: { for: _vm.controlId },
                      },
                      [
                        _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
                        _vm.required
                          ? _c(
                              "span",
                              {
                                staticClass: "required-field",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v(" *")]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.statusText
                  ? _c("span", { staticClass: "text-dark-secondary small" }, [
                      _c("em", [_vm._v(_vm._s(_vm.statusText))]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ml-3" }, [_vm._t("control")], 2),
            ]
          )
        : _c(
            "div",
            { staticClass: "d-flex flex-column" },
            [
              _vm.label
                ? _c(
                    "label",
                    {
                      staticClass: "mb-2 font-weight-bold",
                      attrs: { for: _vm.controlId },
                    },
                    [
                      _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
                      _vm.required
                        ? _c(
                            "span",
                            {
                              staticClass: "required-field",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v(" *")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.readOnlyValue
                ? _c("span", { staticClass: "text-dark-secondary" }, [
                    _vm._v("\n      " + _vm._s(_vm.readOnlyValue) + "\n    "),
                  ])
                : _vm._t("default"),
            ],
            2
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }